/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { User } from './user';
import type { StudentProgressRecordModuleStartDate } from './studentProgressRecordModuleStartDate';
import type { StudentProgressRecordModuleSubmissionDate } from './studentProgressRecordModuleSubmissionDate';
import type { StudentProgressRecordPredictedFinish } from './studentProgressRecordPredictedFinish';
import type { StudentLevelStats } from './studentLevelStats';
import type { StudentProgressRecordPaceAnalysis } from './studentProgressRecordPaceAnalysis';

export interface StudentProgressRecord {
  student: User;
  enrollmentDate: string;
  /** When student started working on the module */
  moduleStartDate: StudentProgressRecordModuleStartDate;
  /** When student submitted the module (if applicable) */
  moduleSubmissionDate: StudentProgressRecordModuleSubmissionDate;
  version: string;
  /** Percentage of tasks completed */
  progressPercent: number;
  /** Whether student has recent activity */
  isActive: boolean;
  /** Sum of individual task timespans */
  moduleTimespansHours?: number;
  /** Timespan from first to last completed task */
  doneTasksTotalTimespan?: number;
  predictedFinish?: StudentProgressRecordPredictedFinish;
  /** Statistics by task level */
  levelStats?: StudentLevelStats[];
  /** Pace analysis vs historical benchmark */
  paceAnalysis: StudentProgressRecordPaceAnalysis;
}
